import { useProfile } from './useProfile';

export const useIsOrganizationLeader = (): boolean | undefined => {
  const { profile, loading } = useProfile();

  if (loading) return;

  if (!profile) return false;

  return profile.ledOrganizations.length > 0;
};
